export default {"src":"/planos/_next/static/media/page404-mobile.64b350b0.svg","height":160,"width":218,"blurWidth":0,"blurHeight":0};